import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.5 14.434V17.25C22.5 18.4838 21.4837 19.5 20.25 19.5H3.75C2.51625 19.5 1.5 18.4838 1.5 17.25V6.75C1.5 5.51625 2.51625 4.5 3.75 4.5H15.843C15.157 4.88064 14.5535 5.39183 14.066 6H3.75C3.32625 6 3 6.32625 3 6.75V8.25H12.939C12.8156 8.72943 12.75 9.23205 12.75 9.75C12.75 10.004 12.7658 10.2543 12.7964 10.5H3V17.25C3 17.6737 3.32625 18 3.75 18H20.25C20.6737 18 21 17.6737 21 17.25V15.3139C21.5442 15.0936 22.0488 14.7957 22.5 14.434Z"
      fill="#2E3A48"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.7826 11.25C23.1372 13.4186 21.1283 15 18.75 15C15.8505 15 13.5 12.6495 13.5 9.75C13.5 6.85051 15.8505 4.5 18.75 4.5C21.1283 4.5 23.1372 6.08138 23.7826 8.25H21.75V9H23.25V9.375H21.75V10.125H23.25V10.5H21.75V11.25H23.7826ZM17.25 10.5V8.25H15.75V9H16.5V10.5H15.75V11.25H18V10.5H17.25ZM18.75 11.25V9.375H20.25V9H18.75V8.25H21V10.125H19.5V10.5H21V11.25H18.75Z"
      fill="#2E3A48"
    />
  </svg>
);
export default SVGComponent;
